import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import Seo from '../components/Seo';
import { useLang } from '../i18n';

export default function NotFound() {
  const { t } = useLang();
  const { pathname } = useLocation();

  return (
    <>
      <Seo title={t('notFound.seoTitle')} description={t('notFound.body')} noIndex />

      <div className="wrap py-24 md:py-32 max-w-2xl">
        <h1 className="font-display text-[clamp(2.5rem,5.5vw,5rem)] leading-[1] tracking-[-0.02em]">{t('notFound.title')}</h1>
        <p className="prosa mt-5">{t('notFound.body')}</p>
        <p className="label mt-2 text-inchiostro/40 break-all">{pathname}</p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link className="btn btn-solid" to="/catalogo">{t('catalog.title')}</Link>
          <Link className="btn btn-line" to="/">{t('nav.home')}</Link>
          <Link className="btn btn-line" to="/dove-comprare">{t('nav.whereToBuy')}</Link>
          <Link className="btn btn-line" to="/storie">{t('stories.title')}</Link>
        </div>
      </div>
    </>
  );
}
